import React, { useContext, useEffect, useState } from 'react';
import { Paginate, BaseModal } from '@cokitchen/cokitchen-components';
import { UserType } from 'models/user.model';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';
import Loader from 'components/base/loader';
import UserOrderCard from 'components/base/cards/user-order-card';
import { useSearchParams } from 'react-router-dom';
import { getOrderStatus } from 'utils/functions';
import { ArrowLeftIcon } from 'cokitchen-icons';
import OrderStatus from 'components/base/order-status';
import OrderDetail from 'pages/order-details';
import { UserProfileContext } from '../context';

const baseUrl = process.env.REACT_APP_ORDER_STATS_API_KEY;

const UserOrders = ({ user }: { user: UserType }) => {
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([] as OrderType[]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeOrder, setActiveOrder] = useState<OrderType>();
  const [showOrderModal, setShowOrderModal] = useState(false);

  const { filters } = useContext(UserProfileContext);

  useEffect(() => {
    setShowOrderModal(!!activeOrder);
    if (activeOrder) {
      searchParams.set('order', activeOrder.order_code);
      searchParams.set('orderStatus', getOrderStatus(activeOrder));
    } else {
      if (searchParams.has('order')) {
        searchParams.delete('order');
        searchParams.delete('orderStatus');
      }
    }
    setSearchParams(searchParams);
  }, [activeOrder]);

  const loadOrders = async (pageNo = 1) => {
    setLoading(true);
    const { id: user_id } = user;
    const res = await apiService.post(
      `user/one/orders/${pageNo}?start=${filters.date.startDate.toISOString()}&end=${filters.date.endDate.toISOString()}`,
      {
        baseUrl,
        data: {
          user_id
        }
      }
    );
    const response = res?.data?.data;
    const data = response?.data;

    const pageCount = Math.ceil(response?.total / 10);
    setPageCount(pageCount);
    setOrders(data);
    setLoading(false);
  };

  const getSelectedPage = (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    loadOrders(pageNo);
  };

  useEffect(() => {
    loadOrders();
  }, []);

  return (
    <div className='pt-8 pb-3 space-y-6'>
      {loading ? (
        <Loader />
      ) : orders.length === 0 ? (
        <div className={`flex items-center justify-center h-full  font-semibold`}>
          No Orders To Show
        </div>
      ) : (
        <div className='grid lg:grid-cols-2 gap-6'>
          {orders?.map((order) => (
            <UserOrderCard key={order.id} item={order} onClick={() => setActiveOrder(order)} />
          ))}
        </div>
      )}
      <Paginate onPageChange={getSelectedPage} pageCount={pageCount} />
      <BaseModal
        position='right'
        isOpen={showOrderModal}
        onRequestClose={() => setActiveOrder(undefined)}
        size='wide'
        title={
          <div className='flex flex-wrap lg:flex-nowrap gap-2 items-center'>
            <button onClick={() => setActiveOrder(undefined)}>
              <ArrowLeftIcon className='w-6 h-6' />
            </button>
            <div className='font-semibold text-2xl'>
              Order #{activeOrder?.order_code?.toUpperCase()}
            </div>

            {activeOrder && (
              <div className='basis-full lg:basis-auto'>
                <OrderStatus type={getOrderStatus(activeOrder)} />
              </div>
            )}
          </div>
        }>
        {activeOrder && <OrderDetail orderCode={activeOrder?.order_code} />}
      </BaseModal>
    </div>
  );
};

export default UserOrders;
